/* istanbul ignore file */

// eslint-disable-next-line import/prefer-default-export
export const resetMakesFilterValues = (compatibleMakes) => {
  const newlyResetMakes = {};

  Object.keys(compatibleMakes).forEach((make) => {
    newlyResetMakes[make] = true;
  });

  return newlyResetMakes;
};
